module.exports = __webpack_public_path__ + "static/media/100.ad2395df.wav";